import { FaqLoadingPlaceholder, useAnalyticsPageViewTracker, useOidcAuthentication } from '@cp-shared-10/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { FaqUi } from './ui';
import { useFaq } from './useFaq';

const FaqWithHandlers = withLoadingAndNoConnectionHandler(FaqUi);

export const Faq: React.FC = () => {
    const { cmsContent: faq, isLoading, loadingError } = useFaq();
    const { isAuthenticated } = useOidcAuthentication();

    useAnalyticsPageViewTracker('faq', !!faq);

    return (
        <FaqWithHandlers
            isLoading={isLoading}
            faq={faq}
            hasError={!!loadingError}
            isLoggedIn={isAuthenticated}
            loadingPlaceholder={<FaqLoadingPlaceholder withDescription />}
        />
    );
};
